class VirtualTour {
  constructor(virtualTour) {
    this.virtualTour = virtualTour;
    this.triggers = virtualTour.querySelectorAll('.js-virtual-tour-trigger');
    this.modal = virtualTour.querySelector('.js-virtual-tour-modal');
    this.modalClose = virtualTour.querySelector('.js-virtual-tour-modal-close');
    this.iframeContainer = virtualTour.querySelector('.js-virtual-tour-modal-container');
    this.tourURL = this.modal.dataset.tourUrl;
    this.tourURL = atob(this.tourURL);
    this.iframe = document.createElement('iframe');
    this.iframe.src = this.tourURL;
    this.focusCheckInterval = 500; // 500 ms
    this.focusCheckIntervalId = null;

    this.initialize();
  }

  initialize() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openModal();
      });
    });

    if (this.modalClose) {
      this.modalClose.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal();
      });
    }

    if (this.modal) {
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          e.preventDefault();
          this.closeModal();
        }
      });
    }
  }

  openModal() {
    this.virtualTour.classList.add('--modal-shown');
    this.iframeContainer.appendChild(this.iframe);
    this.modal.style.opacity = '1';
    this.modal.focus();
    this.handleEscapeKey(true);

    // Set up iframe load listener and start the focus check once the iframe is loaded
    this.iframe.addEventListener('load', () => {
      this.startFocusCheckInterval();
    });
  }

  closeModal() {
    this.virtualTour.classList.remove('--modal-shown');
    this.modal.style.opacity = '0';
    if (this.iframe.parentNode) {
      this.iframe.parentNode.removeChild(this.iframe);
    }
    this.handleEscapeKey(false);

    // Clear focus check interval
    if (this.focusCheckIntervalId) {
      clearInterval(this.focusCheckIntervalId);
      this.focusCheckIntervalId = null;
    }
  }

  handleEscapeKey(enable) {
    if (enable) {
      document.addEventListener('keydown', this.escHandler = (e) => {
        if (e.key === 'Escape') {
          this.closeModal(document.querySelector('.js-virtual-tour.--modal-shown'));
        }
      });
    } else {
      document.removeEventListener('keydown', this.escHandler);
    }
  }

  startFocusCheckInterval() {
    if (this.focusCheckIntervalId) {
      clearInterval(this.focusCheckIntervalId);
    }
    this.focusCheckIntervalId = setInterval(() => {
      const activeElement = document.activeElement;
      if (this.iframe.contains(activeElement)) {
        // Move focus back to parent container so we can use escape key to exit iframe
        const parentContainer = this.modal;
        if (parentContainer) {
          parentContainer.setAttribute('tabindex', '-1');
          parentContainer.focus();
        }
      }
    }, this.focusCheckInterval);
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const virtualTours = [...document.querySelectorAll('.js-virtual-tour')];
  if (virtualTours.length > 0) {
    virtualTours.forEach((virtualTour) => {
      new VirtualTour(virtualTour);
    });
  }
});